import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ITEMEDITMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Couleurs" },
  "background_color",
  "heading_color",
  "description_color",
  "inactive_state_color",
  "price_color",
  { type: 'separator' },
  "hide_addition_group_details"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  itemEditModalDescriptor: _generatedItemEditModalDescriptor,
  itemEditModalModalDefinition,
  itemEditModalDashboardLayout,
  itemEditModalConfig,
  itemEditModalResolveConfig,
  itemEditModalProperties,
} = doodModalConfig(
  {
    name: "Item edit modal",
    handle: "item-edit-modal",
    internal_name: "ItemEditModal",
    componentType: 'ItemEditModalComponent',
    category: 'modal',
    description: "Item edit modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "item-edit-modal",
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        "label": "Titres produits"
      }
    }),
    description_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-700"},
      options: {
        "label": "Description"
      }
    }),
    inactive_state_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-500"},
      options: {
        "label": "Etat inactif"
      }
    }),
    price_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-700"},
      options: {
        "label": "Prix"
      }
    }),
    hide_addition_group_details: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        "label": "Hide the text info of the number of product to choose"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "heading_color", "description_color", "inactive_state_color", "price_color", "hide_addition_group_details"],
          },
        ],
      },
    ],
  })
);

export function itemEditModalDescriptor(): IBlockDescriptor;
export function itemEditModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function itemEditModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedItemEditModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedItemEditModalDescriptor, itemEditModalProperties, fieldOrder);
}

export {
  itemEditModalModalDefinition,
  itemEditModalDashboardLayout,
  itemEditModalProperties,
  itemEditModalConfig,
  itemEditModalResolveConfig,
};

export type ItemEditModalConfig = typeof itemEditModalConfig;
